import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import useSubmittedProposals from '../../hooks/useSubmittedProposals'
import { downloadZipFile } from './utils/fileDownload'

function getMaterialDownloadUrls(data) {
  if (!Array.isArray(data)) {
    return []
  }
  return data.map(doc => {
    return {
      id: doc.id,
      pseudonym: doc.pseudonym,
      downloadUrl: doc.modal.downloadUrl,
      fileName: doc.modal.fileName
    }
  })
}

const DownloadModals = ({ setLoading, setError }) => {
  const { modalData } = useSubmittedProposals()
  const { t } = useTranslation('proposals')
  const urls = getMaterialDownloadUrls(modalData)

  const handleDownload = () => {
    downloadZipFile('3d modals.zip', urls, setLoading, setError)
  }

  return <Wrapper onClick={handleDownload}>{t('3D modals')}</Wrapper>
}

export default DownloadModals

const Wrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`
